var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('startups-header'),_c('search',{attrs:{"search-type":"startups"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }